import React, { Component } from 'react'
import { AppBar, Button, Dialog, DialogActions, DialogContent, Toolbar, Typography, } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles/index'
import { bindActionCreators } from 'redux'
import { UecareAvatar, UecareInput } from '../../../../components'
import ReduxGlobal from '../../../../store/actionreducers/globalView'
import ReduxUser from '../../../../store/actionreducers/user'
import { connect } from 'react-redux'
import { constDataDialogs } from '../../../../constants'
import UecareTextarea from "../../../../components/UecareTextarea"

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    addressButton: {
        margin: theme.spacing.unit * 1 / 2,
    },
    formControl: {
        marginBottom: 24
    },
})

const UserInfo = {
    user: {
        name:'',
        id: '',
        avatar: { url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png' },
    },
}

const mail = {
    title: '',
    content: ''
}

class SystemEmailDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            user: UserInfo,
            ...mail,
        }
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({ name: constDataDialogs.name.systemEmailDialog })
    }

    _sendCustomMail = async action => {
        try {
            const {
                closeLoadingMask,
                sendCustomMail,
                openLoadingMask,
                user: { id: userId },
            } = this.props

            const {
                title,
                context,
            } = this.state

            openLoadingMask()
            if (action === 'send') await sendCustomMail({  userId , subject: title, content: context })
            closeLoadingMask()
        } catch (e) {
            console.warn('you got an error = ', e)
        }
    }

    render() {
        if (!this.props.systemEmailDialog || !this.props.systemEmailDialog.props.open) return <div/>

        const {
            classes,
            systemEmailDialog,
            user,
        } = this.props

        const {
            title,
            context,
        } = this.state

        return (
            <Dialog
                className={classes.root}
                {...systemEmailDialog.props}
                onClose={this.closeDataDialog}
                fullWidth
                maxWidth="xs"
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">系統信件發送</Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <UecareAvatar
                            className="w-96 h-96"
                            src={user.avatar ? user.avatar.url : 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'}
                        />
                        <Typography variant="title" color="inherit" className="pt-8">{user.name}</Typography>
                    </div>
                </AppBar>

                <DialogContent classes={{ root: 'p-24' }}>
                    <UecareInput
                        label="Email"
                        icon="email"
                        name="email"
                        id="email"
                        className={classes.formControl}
                        value={user.email}
                        onChange={() => false}
                        disabled
                    />

                    <UecareInput
                        label="主旨"
                        icon="date_range"
                        name="updated_at"
                        id="updated_at"
                        className={classes.formControl}
                        value={title || ''}
                        onChange={(event) => this.setState({ title: event.target.value })}
                    />

                    <UecareTextarea
                        label="內文"
                        icon="note"
                        name="note"
                        id="note"
                        className={classes.formControl}
                        value={context || ''}
                        onChange={(event) => this.setState({ context: event.target.value })}
                    />
                </DialogContent>

                <DialogActions>
                    <Button variant="raised" color="secondary" onClick={() => this._sendCustomMail('send')}>發送信件</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sendCustomMail: ReduxUser.ActionCreator.sendCustomMail,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch)
}

function mapStateToProps({ global: { dataDialogs }, user: { user }, title, context }) {
    return {
        systemEmailDialog: dataDialogs[constDataDialogs.name.systemEmailDialog],
        user,
        title,
        context,
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(SystemEmailDialog))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/SystemEmailDialog.js